import { render, staticRenderFns } from "./DocumentTableAddDZ.vue?vue&type=template&id=0dd695d1&scoped=true"
import script from "./DocumentTableAddDZ.vue?vue&type=script&lang=js"
export * from "./DocumentTableAddDZ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd695d1",
  null
  
)

export default component.exports